import { defineMessages } from "react-intl";

const messages = defineMessages({
    createPassword: {
        id: "account.password.create",
    },
    cancel: {
        id: "general.cancel",
    },
    newPassword: {
        id: "account.newPassword",
    },
    newPasswordAgain: {
        id: "account.newPasswordAgain",
    },
});

export default messages;
